export const sampleOrder = {
    blockCreatedDateSet: false,
    blockModifiedDateSet: false,
    id: 317,
    compositeIdentifier: 2508081440031,
    source: "",
    thirdPartyReference: "",
    verificationCode: "",
    requestedDate: null,
    feePercentage: null,
    deliveryFee: 0,
    accepted: false,
    orderTypeId: 2,
    processingFee: 0,
    discountAmount: null,
    serviceChargeAmount: null,
    customerLoyaltyAppliedAmount: 0,
    customerId: null,
    discountTypeId: null,
    serviceChargeId: null,
    hasMainCourse: false,
    flagNo: null,
    managerEmployeeId: null,
    operatorEmployeeId: 3669,
    staffEmployeeId: null,
    loyaltyPoints: 0,
    loyaltyPointsBurned: null,
    orderLink: "mo0d2fyiay",
    multiOrderCode: null,
    noReceipt: null,
    ageVerificationCompleted: false,
    posDeviceId: 378,
    merchantId: 144,
    merchant: {
        id: 144,
        name: "Buy N Large",
        businessName: "Buy N Large",
        address: "4421 Blueberry Road, Philadelphia, PA 19191",
        phoneNumber: "+1 (215) 555-01",
        vatNumber: "1234567AB",
        contactEmail: "contact@bigmerchco.com",
        merchantLink: "1cd8f999",
        merchantSocialLinks: [
            {
                id: 37,
                merchantId: 144,
                name: "Facebook",
                link: "https://www.facebook.com/walmart/",
                isActive: true,
            },
            {
                id: 38,
                merchantId: 144,
                name: "Instagram",
                link: "https://www.instagram.com/walmart/",
                isActive: true,
            },
            {
                id: 39,
                merchantId: 144,
                name: "Twitter",
                link: "https://x.com/Walmart",
                isActive: true,
            },
        ],
        brand: {
            preventStockDatesPreparation: false,
            name: "BigMerchCo",
            photoURL: "https://upcoimages.s3.eu-west-1.amazonaws.com/images/product-image/1757063473100%20-%20logo-buy-n-large-2-3x.png",
        },
        currency: {
            symbol: "$",
        },
    },
    serviceType: 1,
    lastOrderStatusId: 1,
    applicationSource: {
        id: 3,
        name: "POS",
    },
    serviceFeeAmount: null,
    checkId: null,
    orderItems: [
        {
            id: 4519332,
            quantity: 1,
            price: 19.99,
            note: null,
            modifierTotal: 0,
            discountAmount: null,
            discountTypeId: null,
            hasProductDiscount: false,
            productId: 18349,
            isBundle: false,
            bundleCombinationId: null,
            bundleIdentifier: null,
            openPrice: null,
            clickedSequence: 1,
            tableSeat: null,
            orderId: 1517170,
            menuId: 775,
            vatRateId: 10,
            vatRateValue: null,
            isUpsell: false,
            isAgeVerification: false,
            drsValue: null,
            product: {
                active: true,
                id: 18349,
                startDate: "2022-04-10T00:00:00.000Z",
                endDate: null,
                name: "Women's High-Rise Skinny Jeans",
                code: null,
                photoURL: "",
                merchantId: 144,
                calorieCount: null,
                productCategoryId: 45483,
                preparationTime: null,
                printName: "Women's High-Rise Skinny Jeans",
                receiptName: null,
                vatRateId: null,
                referenceNumber: null,
                price: 100,
                brandId: 65,
                description: null,
                shortDescription: null,
                pointsGiven: null,
                pointsRequired: null,
                minPrice: 0,
                online: true,
                ABV: null,
                remaining: null,
                color: null,
                region: null,
                type: null,
                tag: "Dinner Menu ",
                hasGroupModifier: false,
                isDiscountable: true,
                isBundle: false,
                isMainCourse: null,
                barCode: null,
                isPopular: false,
                isLoyalty: true,
                isOpenPrice: false,
                isAgeVerification: false,
                drsEnabled: false,
                drsValue: null,
                colorCode: null,
            },
            vatRate: {
                id: 10,
                createdDate: "2021-02-13T00:00:00.000Z",
                lastModifiedUserId: 25,
                version: null,
                vatClass: "IE Standard",
                vatCode: "test",
                countryId: 1,
                effectiveFrom: null,
                vatRateValue: [
                    {
                        id: 5,
                        amount: 6.5,
                        vatRateId: 10,
                        effectiveFrom: "2022-04-01T00:00:00.000Z",
                    },
                ],
            },
            orderItemModifiers: [],
        },
        {
            id: 4519332,
            quantity: 2,
            price: 14.99,
            modifierTotal: 0,
            discountAmount: null,
            discountTypeId: null,
            hasProductDiscount: false,
            productId: 18349,
            clickedSequence: 1,
            orderId: 1517170,
            menuId: 775,
            vatRateId: 10,
            vatRateValue: null,
            drsValue: null,
            product: {
                blockModifiedDateSet: false,
                preventStockDatesPreparation: false,
                active: true,
                id: 18349,
                createdDate: "2022-04-11T16:38:21.000Z",
                modifiedDate: "2024-08-28T15:46:18.000Z",
                lastModifiedUserId: 231,
                version: 14,
                startDate: "2022-04-10T00:00:00.000Z",
                endDate: null,
                name: "Kid's Hoddie (Boys/Girls)",
                priceTag: "@ $14.99 ea",
                code: null,
                photoURL: "",
                merchantId: 144,
                calorieCount: null,
                productCategoryId: 45483,
                preparationTime: null,
                printName: "Kid's Hoddie (Boys/Girls)",
                receiptName: null,
                vatRateId: null,
                referenceNumber: null,
                price: 100,
                brandId: 65,
                description: null,
                shortDescription: null,
                pointsGiven: null,
                pointsRequired: null,
                minPrice: 0,
                online: true,
                ABV: null,
                remaining: null,
                color: null,
                region: null,
                type: null,
                tag: "Dinner Menu ",
                hasGroupModifier: false,
                isDiscountable: true,
                isBundle: false,
                isMainCourse: null,
                barCode: null,
                isPopular: false,
                isLoyalty: true,
                isOpenPrice: false,
                isAgeVerification: false,
                drsEnabled: false,
                drsValue: null,
                colorCode: null,
            },
            vatRate: {
                blockModifiedDateSet: false,
                id: 10,
                createdDate: "2021-02-13T00:00:00.000Z",
                modifiedDate: "2022-07-20T12:13:20.000Z",
                lastModifiedUserId: 25,
                version: null,
                vatClass: "IE Standard",
                vatCode: "test",
                countryId: 1,
                effectiveFrom: null,
                vatRateValue: [
                    {
                                blockModifiedDateSet: false,
                        id: 5,
                        createdDate: "2021-02-13T21:50:55.000Z",
                        modifiedDate: null,
                        lastModifiedUserId: null,
                        version: null,
                        amount: 6.5,
                        vatRateId: 10,
                        saleMediumId: 1,
                        effectiveFrom: "2022-04-01T00:00:00.000Z",
                    },
                ],
            },
            orderItemModifiers: [],
        },
        {
            id: 4519332,
            quantity: 2,
            price: 24.99,
            modifierTotal: 0,
            discountAmount: null,
            discountTypeId: null,
            hasProductDiscount: false,
            productId: 18349,
            clickedSequence: 1,
            orderId: 1517170,
            menuId: 775,
            vatRateId: 10,
            vatRateValue: null,
            drsValue: null,
            product: {
                active: true,
                id: 18349,
                lastModifiedUserId: 231,
                version: 14,
                startDate: "2022-04-10T00:00:00.000Z",
                name: "Slip-On Sneakers (Men/Women)",
                priceTag: "@ $24.99 ea",
                code: null,
                merchantId: 144,
                printName: "Slip-On Sneakers (Men/Women)",
                vatRateId: null,
                price: 100,
                brandId: 65,
                drsValue: null,
            },
            vatRate: {
                id: 10,
                vatClass: "IE Standard",
                vatCode: "test",
                countryId: 1,
                effectiveFrom: null,
                vatRateValue: [
                    {
                        blockModifiedDateSet: false,
                        id: 5,
                        createdDate: "2021-02-13T21:50:55.000Z",
                        modifiedDate: null,
                        lastModifiedUserId: null,
                        version: null,
                        amount: 6.5,
                        vatRateId: 10,
                        saleMediumId: 1,
                        effectiveFrom: "2022-04-01T00:00:00.000Z",
                    },
                ],
            },
            orderItemModifiers: [],
        },

        {
            id: 4519332,
            quantity: 1,
            price: 7.98,
            modifierTotal: 0,
            discountAmount: null,
            discountTypeId: null,
            hasProductDiscount: false,
            productId: 18349,
            clickedSequence: 1,
            orderId: 1517170,
            menuId: 775,
            vatRateId: 10,
            vatRateValue: null,
            drsValue: null,
            product: {
                active: true,
                id: 18349,
                lastModifiedUserId: 231,
                version: 14,
                startDate: "2022-04-10T00:00:00.000Z",
                name: "Baseball Cap",
                code: null,
                merchantId: 144,
                printName: "Baseball Cap",
                vatRateId: null,
                price: 100,
                brandId: 65,
                drsValue: null,
            },
            vatRate: {
                id: 10,
                vatClass: "IE Standard",
                vatCode: "test",
                countryId: 1,
                effectiveFrom: null,
                vatRateValue: [
                    {
                        blockModifiedDateSet: false,
                        id: 5,
                        createdDate: "2021-02-13T21:50:55.000Z",
                        modifiedDate: null,
                        lastModifiedUserId: null,
                        version: null,
                        amount: 6.5,
                        vatRateId: 10,
                        saleMediumId: 1,
                        effectiveFrom: "2022-04-01T00:00:00.000Z",
                    },
                ],
            },
            orderItemModifiers: [],
        },
    ],
    orderPosTableInfo: [
        {
            merchantSaleUnitId: 12,
        }
    ],
    orderPayments: [{}]
};
